var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';
import "../../enums/accordion.js";
import "../../enums/alert.js";
import "../../enums/avatar.js";
import "../../enums/breakpoints.js";
import "../../enums/button.js";
import "../../enums/code-editor.js";
import "../../enums/colors.js";
import "../../enums/combobox.js";
import "../../enums/date.js";
import "../../enums/drag-and-drop.js";
import "../../enums/dialog.js";
import "../../enums/divider.js";
import "../../enums/dropdown.js";
import "../../enums/fieldset.js";
import "../../enums/font-icon.js";
import "../../enums/fonts.js";
import "../../enums/headings.js";
import "../../enums/input.js";
import "../../enums/keys.js";
import "../../enums/list.js";
import "../../enums/listbox.js";
import "../../enums/loader.js";
import "../../enums/margin.js";
import "../../enums/option.js";
import "../../enums/pill.js";
import "../../enums/placements.js";
import "../../enums/popout.js";
import "../../enums/privacy.js";
import "../../enums/radio-group.js";
import "../../enums/status.js";
import "../../enums/switch.js";
import "../../enums/table.js";
import { TooltipPositions } from "../../enums/tooltip.js";
import "../../enums/transitions.js";
import "../../enums/widths.js";
import "../../themes/alert.js";
import { borderRadiusXLarge } from "../../themes/borders.js";
import "../../themes/button.js";
import "../../themes/checkbox.js";
import "../../themes/divider.js";
import "../../themes/dropdown.js";
import "../../themes/fieldset.js";
import { fontFamilyBook } from "../../themes/fonts.js";
import "../../themes/input.js";
import "../../themes/list.js";
import "../../themes/listbox.js";
import "../../themes/loader.js";
import "../../themes/option.js";
import "../../themes/popout.js";
import "../../themes/switch.js";
import "../../themes/themes.js";
import "../../themes/tooltip.js";
var baseTooltipStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: inline-block;\n  position: relative;\n\n  &::after,\n  &::before {\n    position: absolute;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease;\n  }\n\n  &::after {\n    content: '';\n    width: 0;\n    height: 0;\n  }\n\n  &::before {\n    border-radius: ", "px;\n    content: attr(data-tooltip);\n    font-family: ", ";\n    font-size: 13px;\n    line-height: 21px;\n    padding: 10px 13px;\n    text-align: center;\n    white-space: nowrap;\n    z-index: 2;\n  }\n\n  &:hover {\n    &::after,\n    &::before {\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n"])), borderRadiusXLarge, fontFamilyBook);
/**
 * Get Styled Component tooltip color styles
 * @param options getTooltipLookOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getTooltipLook = function getTooltipLook(options) {
  var look = options.look;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    &::before {\n      background-color: ", ";\n      color: ", ";\n    }\n  "])), function (_ref) {
    var theme = _ref.theme;
    return theme.tooltip[look].backgroundColor;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.tooltip[look].textColor;
  });
};
/**
 * Get Styled Component tooltip position styles
 * @param options GetTooltipPositionOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getTooltipPosition = function getTooltipPosition(options) {
  var look = options.look,
    position = options.position;
  switch (position) {
    case TooltipPositions.Bottom:
      {
        return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        &::after,\n        &::before {\n          top: 100%;\n          left: 50%;\n          transform: translate(-50%);\n          margin-top: 10px;\n        }\n        &::after {\n          margin-top: 3px;\n          border-left: 8px solid transparent;\n          border-right: 8px solid transparent;\n          border-bottom: 7px solid ", ";\n        }\n        ", "\n      "])), function (_ref3) {
          var theme = _ref3.theme;
          return theme.tooltip[look].backgroundColor;
        }, getTooltipLook({
          look: look
        }));
      }
    case TooltipPositions.Left:
      {
        return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        &::after,\n        &::before {\n          top: 50%;\n          right: 100%;\n          transform: translate(0, -50%);\n          margin-right: 10px;\n        }\n        &::after {\n          margin-right: 3px;\n          border-top: 8px solid transparent;\n          border-left: 7px solid ", ";\n          border-bottom: 8px solid transparent;\n        }\n        ", "\n      "])), function (_ref4) {
          var theme = _ref4.theme;
          return theme.tooltip[look].backgroundColor;
        }, getTooltipLook({
          look: look
        }));
      }
    case TooltipPositions.Right:
      {
        return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        &::after,\n        &::before {\n          top: 50%;\n          left: 100%;\n          transform: translate(0, -50%);\n          margin-left: 10px;\n        }\n        &::after {\n          margin-left: 3px;\n          border-top: 8px solid transparent;\n          border-right: 7px solid ", ";\n          border-bottom: 8px solid transparent;\n        }\n        ", "\n      "])), function (_ref5) {
          var theme = _ref5.theme;
          return theme.tooltip[look].backgroundColor;
        }, getTooltipLook({
          look: look
        }));
      }
    default:
      {
        // TooltipPositions.Top
        return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        &::after,\n        &::before {\n          bottom: 100%;\n          left: 50%;\n          transform: translate(-50%);\n          margin-bottom: 10px;\n        }\n        &::after {\n          margin-bottom: 3px;\n          border-left: 8px solid transparent;\n          border-right: 8px solid transparent;\n          border-top: 7px solid ", ";\n        }\n        ", "\n      "])), function (_ref6) {
          var theme = _ref6.theme;
          return theme.tooltip[look].backgroundColor;
        }, getTooltipLook({
          look: look
        }));
      }
  }
};
export { baseTooltipStyle, getTooltipLook, getTooltipPosition };